/* eslint-disable no-unused-vars */
import React, { useState, useCallback, useMemo, useEffect, useRef } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Badge } from '../components/ui/badge';
import { Textarea } from '../components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../components/ui/dialog';
import {
  Building2,
  CheckCircle2,
  XCircle,
  AlertCircle,
  ArrowLeft,
  Plus,
  RefreshCw,
  Archive,
  ExternalLink,
  Loader2,
  HardHat,
  ShieldCheck,
  Hourglass,
  FileSignature,
  FolderArchive,
  FileText,
  Upload,
  Scale,
  Calculator,
} from 'lucide-react';



export const CcmiPaywallDialog = ({ ctx }) => {
  const {
    analyzingDocId, archiving, assigningJuriste, autosaveAt, autosaveError, autosaveStatus,
    autosaveTick, complianceDraft, complianceLoading, complianceSaving, compliancingDoc, counts,
    creating, creatingFinalDevis, draft, filterStatut, finalContractPaywall,
    generatingFinalContract, generatingPdf, importingPdf, items, juristeAssignLoading,
    juristeCommentInput, juristeEmailInput, loadError, loading, reportingDocId, reviewingDocId,
    search, selected, showCreate, syncing,
    setAnalyzingDocId, setArchiving, setAssigningJuriste, setAutosaveAt, setAutosaveError,
    setAutosaveStatus, setAutosaveTick, setComplianceDraft, setComplianceLoading, setComplianceSaving,
    setCompliancingDoc, setCounts, setCreating, setCreatingFinalDevis, setDraft,
    setFilterStatut, setFinalContractPaywall, setGeneratingFinalContract, setGeneratingPdf,
    setImportingPdf, setItems, setJuristeAssignLoading, setJuristeCommentInput, setJuristeEmailInput,
    setLoadError, setLoading, setReportingDocId, setReviewingDocId, setSearch, setSelected,
    setShowCreate, setSyncing,
    autosaveBaselineRef, autosaveTimerRef, fetchList, fetchedOnce, fileInputRef, handleAnalyzeDoc,
    handleArchive, handleCreate, handleCreateFinalContractDevis, handleDownloadReviewReport,
    handleGenerateFinalContract, handleGeneratePdf, handleImportPdf, handleReviewAi, handleSync,
    navigate, openComplianceModal, openJuristeAssign, saveComplianceDraft, submitComplianceDraft,
    submitJuristeAssign, triggerAutosave,
    STATUT_META, GUARD_STATUS_META, getAuthHeader, CCMI_COMPLIANCE_CHECKLIST, computeComplianceStatus,
    ComplianceStatusPanel, AutosaveIndicator,
  } = ctx;
  return (
      <Dialog open={!!finalContractPaywall} onOpenChange={(open) => { if (!open) setFinalContractPaywall(null); }}>
        <DialogContent className="max-w-lg" data-testid="ccmi-final-contract-paywall-dialog">
          <DialogHeader>
            <DialogTitle className="text-emerald-800">
              Service payant — Contrat CCMI définitif
            </DialogTitle>
            <DialogDescription className="text-slate-700">
              La génération du contrat CCMI définitif imprimable est un service payant
              du programme LEGALCOOP.
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-3 text-sm text-slate-800">
            <div className="rounded-md border border-emerald-200 bg-emerald-50 p-3">
              <div className="font-semibold text-emerald-900">
                Forfait Contrat CCMI définitif imprimable
              </div>
              <div className="text-emerald-900 mt-1">
                <span className="font-bold">{finalContractPaywall?.amount_ht ?? 500} € HT</span> par projet CCMI
              </div>
              <div className="text-xs text-emerald-800 mt-1">
                Dossier : <span className="font-mono">{finalContractPaywall?.project?.reference}</span>
              </div>
            </div>
            {finalContractPaywall?.message ? (
              <p className="text-slate-700 text-sm" data-testid="ccmi-final-contract-paywall-message">
                {finalContractPaywall.message}
              </p>
            ) : null}
            <p className="text-xs text-slate-600">
              Pour débloquer la génération, un devis LEGALCOOP sera créé pour ce projet.
              Une fois le devis accepté et la facture réglée (ou conversion off-platform),
              vous pourrez générer le contrat CCMI définitif.
            </p>
          </div>
          <DialogFooter>
            <Button
              variant="outline"
              onClick={() => setFinalContractPaywall(null)}
              disabled={creatingFinalDevis}
              data-testid="ccmi-final-contract-paywall-cancel"
            >
              Annuler
            </Button>
            <Button
              onClick={handleCreateFinalContractDevis}
              disabled={creatingFinalDevis}
              className="bg-emerald-700 hover:bg-emerald-800 text-white"
              data-testid="ccmi-final-contract-paywall-create-devis"
            >
              {creatingFinalDevis ? <Loader2 className="h-4 w-4 animate-spin mr-1" /> : <FileText className="h-4 w-4 mr-1" />}
              Générer un devis LEGALCOOP
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
  );
};

export default CcmiPaywallDialog;
